"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = applyWhitelist;
var _fp = require("lodash/fp");
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Copies a value from the source object to the destination object at the same path, but only if there is a defined value at that path.
 *
 * @param {object} source - Object which contains the value to be copied.
 * @param {object} destination - Object which values will be copied into.
 * @param {string} path - Path of the property to be copied between objects.
 */
function setIfDefined(source, destination, path) {
  var sourceValue = (0, _fp.get)(path, source);
  if (!(0, _fp.isUndefined)(sourceValue)) {
    _lodash["default"].set(destination, path, sourceValue);
  }
}

/**
 * Takes a source object and returns a new object which only contains those properties which are mentioned on the whitelist.
 *
 * @param {object} source - The object which is to be filtered down to contain only properties on the whitelist.
 * @param {Array} whitelist - The whitelist of properties. Can include nested propeties (e.g. 'a.b.c') and even nested array properties (e.g. 'a[].b').
 * @returns {object} - New object containing only whitelisted properties of the source object.
 */
function applyWhitelist(source, whitelist) {
  var result = {};
  (0, _fp.forEach)(function (propertyPath) {
    // Lodash's _.get doesn't handle this array syntax (it only handles specifying a specific array element).
    if ((0, _fp.includes)('[]', propertyPath)) {
      var pathParts = (0, _fp.split)('.', propertyPath);

      // Build a collection of paths that _.get CAN understand
      var arrayPaths = [];
      (0, _fp.forEach)(function (part) {
        var property = (0, _fp.replace)(/\[\]/g, '', part);
        var isArray = (0, _fp.includes)('[]', part);
        var isFirst = (0, _fp.isEmpty)(arrayPaths);
        if (isFirst) {
          arrayPaths = isArray ? (0, _fp.times)(function (index) {
            return "".concat(property, "[").concat(index, "]");
          }, (0, _fp.size)((0, _fp.get)(property, source))) : [property];
          return;
        }
        arrayPaths = isArray ? (0, _fp.flatMap)(function (arrayPath) {
          var sourceArray = (0, _fp.get)("".concat(arrayPath, ".").concat(property), source);
          return (0, _fp.times)(function (index) {
            return "".concat(arrayPath, ".").concat(property, "[").concat(index, "]");
          }, (0, _fp.size)(sourceArray));
        }, arrayPaths) : (0, _fp.map)(function (arrayPath) {
          return "".concat(arrayPath, ".").concat(property);
        }, arrayPaths);
      }, pathParts);

      // Finally, copy them onto the result object
      (0, _fp.forEach)(function (arrayPath) {
        setIfDefined(source, result, arrayPath);
      }, arrayPaths);
      return;
    }
    setIfDefined(source, result, propertyPath);
  }, whitelist);
  return result;
}
module.exports = exports.default;